import { InertiaApp } from "@inertiajs/inertia-vue";
import Vue from "vue";
import { InertiaProgress } from "@inertiajs/progress";
import { Translations } from "./base";
import { Pipeline } from "@/Pages/Pipeline";
import { Dashboard } from "@/Pages/Dashboard";
import VueConfetti from "vue-confetti";
import { createInertiaApp } from '@inertiajs/inertia-vue'

InertiaProgress.init({
  showSpinner: true,
  color: 'var(--primary-color)',
});

createInertiaApp({
    resolve: name => import(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin)
        Vue.use(InertiaApp)
        Vue.mixin(Translations)
        Vue.use(VueConfetti)

      new Vue({
        render: h => h(App, props),
      }).$mount(el)
    },
  })
